import React from "react";
import "./filter-options-tenant.scss";
import { CustomCheckbox } from "../../../../common/components";
import { STATUS_OPTIONS, StatusFilterProps } from "./tenant-filter-helper";

const StatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  error,
  isStatusEnabled,
}) => {
  if (!isStatusEnabled) return null;

  const handleChange = (status: string) => {
    if (value.includes(status)) {
      onChange(value.filter((s) => s !== status));
    } else {
      onChange([...value, status]);
    }
  };

  return (
    <div className="tenant-filter-options-text-wrapper">
      <div className="filter-options-tenant-status-filter">
        <div className="status-checkbox-wrapper">
          {STATUS_OPTIONS.map(({ label, value: val }) => (
            <CustomCheckbox
              key={val}
              checked={value.includes(val)}
              onChange={() => handleChange(val)}
              label={label}
            />
          ))}
        </div>
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default StatusFilter;
